(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.select2 = {
    attach: function (context, settings) {
      once("select2", ".js-select2", context);

      $(once("open", ".js-select2", context))
        .on("select2:open", function (e) {
          const input = e.target;
          const container = input.closest(".form__row");
          container.classList.add("has-focus");
          $(".select2-search__field", context)[0].focus();
        });

      $(once("close", ".js-select2", context))
        .on("select2:close", (e) => {
          const input = e.target;
          const container = input.closest(".form__row");
          if (input.classList.contains("required")) {
            if (input.value.trim() === "") {
              input.classList.add("is-empty");
              input.classList.remove("not-empty");
            } else {
              input.classList.remove("is-empty");
              input.classList.add("not-empty");
            }
          }
          if (input.value.trim() === "") {
            container.classList.remove("has-focus");
          }
        });
      $("select").val([]);
      $("select").select2({
        placeholder: "",
      });
      $(".js-select2-without-search").select2({
        minimumResultsForSearch: -1,
      });
    },
  };
})(jQuery, Drupal, once);
